import React from 'react';
import { Container, Card } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';
import { CheckerContent } from '../components/CheckerContent';

const CheckerPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const sku = searchParams.get('sku') || '';
  const subject = searchParams.get('subject') || '';
  const initialValue = sku || subject;
  const forceSubject = !!subject;

  return (
    <Container fluid className="py-4">
      <h2 className="mb-4">Чекер</h2>
      <Card>
        <Card.Body style={{ display: 'flex', flexDirection: 'column', minHeight: '75vh' }}>
          <CheckerContent initialSku={initialValue} initialSearchAsSubject={forceSubject} />
        </Card.Body>
      </Card>
    </Container>
  );
};

export default CheckerPage;
